export default __webpack_public_path__ + "static/media/155.c757649d.gif";